import React, { Component } from 'react';

import {
    Redirect
} from "react-router-dom";
import {connect} from 'react-redux';
import {api} from '../utils/common';
import {login, loginByToken} from '../actions/Login';
import {setting} from '../actions/ValidateSetting';
import {LoginType} from '../utils/status';
import {Screen, validateSettingAccessibility} from '../utils/common';
import {Loader} from '../components/Loader';
import LoadingScreen from './Main//LoadingScreen';
import { RequestGet } from '../apiClient/api/RequestService';

class Login extends Component {
    constructor(props){
        super(props);
        this.state = {
            token: "",
            phone: localStorage.getItem("phone") || "",
            password: "",
            recentLoginType: LoginType.Token,
            accountErrMsg: "",
            passErrMsg: "",
            tokenErrMsg: "",
            errorMsg: "",
            rememberPhoneChecked: false,
            nextStage: null,

            isTokenValid: false,
            isAuthenticating: true,
        }
    }

    authenticated= (type) => {
        this.setState({
            isAuthenticating: false,
            isTokenValid: type
        }, () => {
            if(!type) {
                this.props.dispatch({type: "RESET_QUEUE"});
                this.props.dispatch({type: "USER_LOGOUT"});
            }
            else {
                this.setState({
                    nextStage: this.props.isValidated ? Screen.HOME : Screen.SETTING
                })
            }
        })
        
    }

    authenticate = async () => {
        const {token} = this.props;
		if (!token) {
			return this.authenticated(false);
        }

        // const res = await RequestGet('/v1/account/check-login', token)

        // if (res?.return_code === 1) {
        //     return this.authenticated(true);
        // }
        return this.authenticated(true);
    }
    
    handleEnterPress = (e) =>{
        e.preventDefault();
        if( e.keyCode === 13){
            if(this.state.recentLoginType === LoginType.Token)
                return this.handleLoginToken();
            else 
                return this.handleLoginAccount();
        }
    }

    handleLoginAccount = () => {
        let {phone, password,rememberPhoneChecked} = this.state;
        phone = phone.trim();
        password = password.trim();
        this.setState({
            phone: phone
        })
        this.setState({
            password: password
        })

        if (!phone) {
            this.setState({
                accountErrMsg: "Tên đăng nhập không được để trống"
            })
            return this.phone.focus();
        }
        else if (phone.length < 8) {
            this.setState({
                accountErrMsg: "Vui lòng nhập tối thiểu 8 ký tự số"
            })
            return this.phone.focus();
        }else if (phone.length > 11) {
            this.setState({
                accountErrMsg: "Vui lòng nhập tối đa 11 ký tự số"
            })
            return this.phone.focus();
        }

        const msgFor = {
            limitCharacters: 'Vui lòng nhập tối đa 64 ký tự',
            minimumCharacters: 'Vui lòng nhập tối thiểu 6 ký tự',
            notEmpty: 'Mật khẩu không được để trống'
        }

        if (!password) {
            this.setState({
                passErrMsg: msgFor.notEmpty
            })
            return this.password.focus();
        }else if (password.length < 6) {
            this.setState({
                passErrMsg: msgFor.minimumCharacters
            })
            return this.password.focus();
        }else if (password.length > 64) {
            this.setState({
                passErrMsg: msgFor.limitCharacters
            })
            return this.password.focus();
        }

        if (rememberPhoneChecked) {
            localStorage.setItem("phone",phone);
        }
        else {
            localStorage.removeItem("phone");
        }

        this.props.dispatch(login(phone,password));
    }

    handleLoginToken = () => {
        let {token} = this.state;
        token = token.trim();
        this.setState({
            token: token
        })
        if(!token){
            this.setState({
                tokenErrMsg: "Token không được để trống"
            })
            return this.token.focus();
        }

        this.props.dispatch(loginByToken(token));
    }

    setToken = (e) => {
        this.setState({
            token: e.target.value
        })
    }
    setPhone = (e) => {
        this.setState({
            phone: e.target.value
        }, () => {
            if (this.state.phone) {
                this.setState({
                    accountErrMsg: ""
                })
            }
            else {
                this.setState({
                    accountErrMsg: "Tên đăng nhập không được để trống"
                })
            }
        })
    }
    setPass = (e) => {
        this.setState({
            password: e.target.value
        }, () => {
            if (this.state.password) {
                this.setState({
                    passErrMsg: ""
                })
            }
            else {
                this.setState({
                    passErrMsg: "Mật khẩu không được để trống"
                })
            }
        })
    }
    showErrorMessage = (msg, type) => {
        switch (type){
            case LoginType.Token : return this.setState({ errorMsg : msg});//tokenErrMsg
            case LoginType.Account : return this.setState({ errorMsg : msg});//accountErrMsg
        }
    }

    logOut = () => {
        this.props.dispatch({type: "RESET_QUEUE"});
        this.props.dispatch({type: "USER_LOGOUT"});
        localStorage.removeItem("persist:root");
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.tokenErrMsg) {
			return this.showErrorMessage(nextProps.tokenErrMsg,LoginType.Token);
        }
        
        if (nextProps.accountErrMsg) {
			return this.showErrorMessage(nextProps.accountErrMsg,LoginType.Account);
        }
        
        if (nextProps.validateMessage) {
			return this.showErrorMessage(nextProps.validateMessage,this.state.recentLoginType);
		}

		if (nextProps.logged) {
			if (nextProps.isValidated)
                return this.setState({ nextStage : Screen.HOME});
			else {
				let {loginResult} = nextProps;
                
                if(validateSettingAccessibility(loginResult))
				    return this.setState({ nextStage : Screen.SETTING});
				else {
                    let branchData = loginResult?.branches[0];
                    let appData = loginResult?.apps[0];
                    if (!appData) {
                        this.setState({ errorMsg: 'Tài khoản của bạn hiện đang ở trạng thái không hoạt động. Vui lòng liên hệ bộ phận hỗ trợ khách hàng để kích hoạt lại tài khoản.' })
                        this.logOut();
                        return;
                    }

					let content = {
						appId: appData.id,
						appName: appData.name,
						branchName: branchData.name,
						branchId: branchData.branch_id,
						storeId: branchData.stores[0].store_id,
						storeName: branchData.stores[0].name,
						cashierId: branchData.stores[0].cashiers[0].cashier_id,
                        cashierName: branchData.stores[0].cashiers[0].name,
                        payWaitConfirm: branchData.stores[0].cashiers[0].payWaitConfirm
                    };
                    
                    const token = {
                        access_token: nextProps.token,
                        refresh_token: nextProps.loginResult.refresh_token
                    }
                    console.log('login >> ', token);
					this.props.dispatch(setting(content, token))
				}
			}
		}
    }

    componentDidMount(){
        document.addEventListener('keyup', this.handleEnterPress);
        this.authenticate();
    }

    componentWillUnmount(){
        document.removeEventListener('keyup', this.handleEnterPress)
    }

    render() {
        let {token, phone, password, rememberPhoneChecked,tokenErrMsg, 
            accountErrMsg, passErrMsg, errorMsg, nextStage} = this.state;
        let {isLogging} = this.props;

        if(this.state.isAuthenticating) return <LoadingScreen/>

        switch (nextStage){
            case Screen.HOME: return <Redirect to='/home' />
            case Screen.SETTING: return <Redirect to='/setting' />
        }

        return (
            <React.Fragment>
            <div className="container maxW-450 mt-4">

                <div className="text-center mb-5">
                    <img src="/cashier/shop/static/assets/images/logo-zalopay.svg" alt="" />
                    <div className="mt-2 txtBlack ls1"><strong>MERCHANT</strong></div>
                </div>
                {
                    isLogging ? null :
                    <ul className="nav nav-pills justify-content-center" id="login-tab">
                        <li className="nav-item">
                            <a className="nav-link active" id="home-tab" data-toggle="tab" onClick={() => this.setState({errorMsg: "", recentLoginType: LoginType.Token})} href="#token">Dùng Token</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" id="profile-tab" data-toggle="tab" onClick={() => this.setState({errorMsg: "", recentLoginType: LoginType.Account})} href="#account">Dùng tài khoản</a>
                        </li>
                    </ul>
                }
                {
                    errorMsg ? <div className="alert alert-danger fade show mt-4 mb-0 fs-s" role="alert">{errorMsg}</div> : null
                }
                <div className="tab-content">
                    <div className="tab-pane fade show active" id="token">
                        <form className="needs-validation" onSubmit={e => e.preventDefault()}>
                            <div className="form-group mt-5 mb-5">
                                <label>TOKEN</label>
                                <input ref={i => this.token = i} type="password" autoComplete="false" className="form-control" placeholder="Nhập token..." required value={token} 
                                    onChange={this.setToken}
                                    />
                                <div className="invalid-feedback" style={{display: "block",marginTop: "10px"}}>{tokenErrMsg}</div>
                            </div>

                            <div className="text-center">
                                {
                                    isLogging ? <Loader/> :			
                                    <input type="button" ref={i => this.loginTokenBtn = i} className="btn btn-main minW-200" value="ĐĂNG NHẬP" 
                                        onClick={this.handleLoginToken}/>
                                }
                            </div>
                        </form>
                    </div>
                    <div className="tab-pane fade" id="account">
                        <form className="needs-validation" onSubmit={e => e.preventDefault()}>
                            <div className="form-group mt-5">
                                <label>TÊN ĐĂNG NHẬP</label>
                                <input ref={ i => this.phone = i} type="text" className="form-control" placeholder="Nhập số điện thoại..." required value={phone}
                                    onChange={this.setPhone}
                                    />
                                    <div className="invalid-feedback" style={{display: "block", marginTop: "5px"}}>{accountErrMsg}</div>
                            </div>

                            <div className="form-group">
                                <label>MẬT KHẨU</label>
                                <input ref={ i => this.password = i} type="password" autoComplete="true" className="form-control" placeholder="Nhập mật khẩu..." required value={password}
                                    onChange={this.setPass}
                                    />
                                    <div className="invalid-feedback" style={{display: "block", marginTop: "5px"}}>{passErrMsg}</div>

                            </div>

                            <div className="custom-control custom-checkbox mb-5">
                                <input type="checkbox" className="custom-control-input" id="customCheck1" checked={rememberPhoneChecked} 
                                    onChange={() => this.setState({ rememberPhoneChecked: !rememberPhoneChecked})} />
                                <label className="custom-control-label optional" htmlFor="customCheck1">Nhớ tài khoản</label>
                            </div>

                            <div className="text-center">	
                                {
                                    isLogging ? <Loader/> :			
                                    <input type="button" ref={i => this.loginAccBtn = i} className="btn btn-main minW-200" value="ĐĂNG NHẬP" 
                                        onClick={this.handleLoginAccount}/>
                                }
                            </div>
                            
                        </form>
                    </div>
                    
                </div>
                        
            </div>


            <div id="footer">
                <div className="city-bg">&nbsp;</div>
                <div className="copyright">&copy; Phát triển bởi ZaloPay</div>
            </div>

            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		loginResult: state.loginData.result,
        accountErrMsg: state.loginData.accountErrMsg,
        tokenErrMsg: state.loginData.tokenErrMsg,
        token: state.loginData.token,
		logged: state.loginData.logged,
		isLogging: state.loginData.isLogging,
		isValidated: state.settingData.isValidated,
		validateMessage: state.settingData.message
	}
};

export default connect(mapStateToProps)(Login);
